import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {SkeletonLine} from '@wix/wix-ui-tpa/cssVars'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useWidgetHost, useWidgetState} from '../../../../../../hooks/state-provider'
import {
  getDayNumber,
  getEventsForDay,
  getToday,
  isCalendarPageLoading,
} from '../../../../../../selectors/calendar-layout'
import {getBorderStyle} from '../../../../../../utils/calendar'
import {MobileMonthlyEvent} from './event'
import {MobileMonthlyDayProps} from './interfaces'
import s from './mobile-monthly-day.scss'

export const MobileMonthlyDay = ({day}: MobileMonthlyDayProps) => {
  const {experiments} = useExperiments()

  const events = useWidgetState(state => getEventsForDay(state, day))
  const dayNumber = useWidgetState(state => getDayNumber(state, day))
  const todayDate = useWidgetState(getToday)
  const host = useWidgetHost()
  const pageLoading = useWidgetState(isCalendarPageLoading)

  const past = day < todayDate
  const today = day === todayDate
  const borderStyleRight = getBorderStyle({host}, 'right')
  const borderStyleBottom = getBorderStyle({host}, 'bottom')
  const mobileCalendarRewireEnabled = experiments.enabled(ExperimentNames.MobileCalendarRewire)
  const loading = experiments.enabled(ExperimentNames.CalendarRevamp) && pageLoading

  return (
    <div data-hook={`calendar-day-${dayNumber}`} className={s.content}>
      <div
        className={classNames(s.day, {
          [s.rewire]: mobileCalendarRewireEnabled,
          [s.past]: past && !mobileCalendarRewireEnabled,
          [s.today]: today && !mobileCalendarRewireEnabled,
          [s.skeleton]: loading,
        })}
        style={mobileCalendarRewireEnabled ? undefined : borderStyleRight}
      >
        {loading ? (
          <SkeletonLine className={s.skeletonLine} />
        ) : (
          <div className={s.dayText} data-hook={`day-of-month-${dayNumber}`}>
            {dayNumber}
          </div>
        )}
      </div>
      {loading ? (
        <div className={s.eventSkeleton}>
          <SkeletonLine className={s.skeletonLine} />
        </div>
      ) : (
        <ul className={s.events}>
          {events.map(event => (
            <li
              key={event.id}
              className={classNames(s.event, {[s.rewire]: mobileCalendarRewireEnabled})}
              style={mobileCalendarRewireEnabled ? undefined : borderStyleBottom}
            >
              <MobileMonthlyEvent event={event} currentDate={day} />
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}
